'use client';

import { create } from 'zustand';

interface ToastState {
  message: string;
  isVisible: boolean;
  type: 'success' | 'error' | 'info' | 'warning';
  duration: number;
}

interface ToastStore {
  toast: ToastState;
  showToast: (message: string, type?: 'success' | 'error' | 'info' | 'warning', duration?: number) => void;
  hideToast: () => void;
}

export const useToastStore = create<ToastStore>((set) => ({
  toast: {
    message: '',
    isVisible: false,
    type: 'success',
    duration: 3000,
  },
  showToast: (message: string, type = 'success', duration = 3000) => {
    set({
      toast: {
        message,
        isVisible: true,
        type,
        duration,
      },
    });
  },
  hideToast: () => {
    set((state) => ({
      toast: {
        ...state.toast,
        isVisible: false,
      },
    }));
  },
}));
